import { IAggregator, IConfiguredAddon, IEndpoint } from '../../types/aggregator.types';

export const getSyncEndpoint = (
  externalSystems: IAggregator[] = [],
  endpointName = 'recipe management',
): IEndpoint | null => {
  const availableEndpoints: IEndpoint[] = [];

  externalSystems.forEach((externalSystem: IAggregator) => {
    externalSystem.configuredAddons.forEach((addon: IConfiguredAddon) => {
      addon.endpoints.forEach((endpoint: IEndpoint) => {
        availableEndpoints.push({ ...endpoint, name: externalSystem.name });
      });
    });
  });

  const syncedEndpoints = availableEndpoints.find(
    (endpoint) => endpoint.endpointName.toLowerCase() === endpointName.toLowerCase(),
  );

  return syncedEndpoints ? syncedEndpoints : null;
};
